// extracted by mini-css-extract-plugin
module.exports = {"skewed_card_outer":"SkewedCard-module--skewed_card_outer--3Jtk3","whiteTop":"SkewedCard-module--whiteTop--1o7N1","KeyVisual":"SkewedCard-module--KeyVisual--3TJqS"};